











import Vue from 'vue';
import LoadingPage from '@/components/LoadingPage.vue';
import Analytics from '@/helpers/analytics';
import viewsNames from './router/viewsNames';
import { Icon, Tooltip } from '@/components/ds';
import {
  showEqualWebDrawer,
  installEqualWebLaunchButtonOffscreenStyle,
} from './helpers/accessibility';
import { initVlibras } from './helpers/vlibras';
import { startTranslationDetection } from './helpers/translationDetection';

const equalWebSiteKey = 'aecf6ffe12fa1c1d26fe0ed3b1d39c4a';
const equalWebIntegrityKey =
  'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';

export default Vue.extend({
  components: { LoadingPage, Icon, Tooltip },
  data() {
    return { isLoading: false };
  },
  computed: {
    isLoadingApp(): boolean {
      return this.$store.getters.isLoadingApp;
    },
  },
  async mounted() {
    // antes de qualquer early return: tradutor ativo é justamente o cenário em que o
    // funil quebra, e queremos o dado inclusive nas rotas que saem cedo daqui
    startTranslationDetection();

    const isLoginValidation = this.$router.currentRoute.name === viewsNames.VALIDATE_LOGIN;
    if (isLoginValidation) return;

    // ProUni is an independent flow with its own pipeline and pocket-only auth.
    // It must not trigger the enrollment bootstrap (which requires an admission).
    const isProuniRoute = (this.$router.currentRoute.path || '').startsWith('/prouni');
    if (isProuniRoute) return;

    try {
      this.isLoading = true;
      const hasEnrollment = await this.$store.dispatch('GET_ENROLLMENT');

      if (!hasEnrollment) {
        await this.$store.dispatch('UPSERT_ENROLLMENT', {});
      }

      await this.$store.dispatch('PULL_PIPELINE');
      await this.$store.dispatch('START_PIPELINE');

      const { email, fullName: name } = this.$store.getters.personalData || {};
      Analytics.identify({ id: email, email, name });
    } catch (err) {
      const admissionsUrl: string = process.env.VUE_APP_ADMISSIONS_URL || '/';

      window.location.replace(admissionsUrl);
    } finally {
      this.isLoading = false;
    }

    this.insertEqualWebScript();
  },
  methods: {
    insertEqualWebScript(): void {
      if ((window as any).descomplicaEqualWebInjected) {
        return;
      }
      (window as any).descomplicaEqualWebInjected = true;

      (window as any).interdeal = {
        sitekey: equalWebSiteKey,
        hideBtn: true,
        Position: 'Right',
        Menulang: 'PT',
        domains: {
          js: 'https://cdn.equalweb.com/',
          acc: 'https://access.equalweb.com/',
        },
        btnStyle: {
          vPosition: [null, '20%'],
          color: {
            main: '#2E850F',
            second: '#000000',
          },
          scale: [0.5],
          icon: {
            type: 1,
            shape: 'circle',
            outline: false,
          },
        },
      };

      // Accessibility Utilitary
      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://cdn.equalweb.com/core/5.2.0/accessibility.js';
      scriptElement.defer = true;
      scriptElement.integrity = equalWebIntegrityKey;
      scriptElement.crossOrigin = 'anonymous';
      scriptElement.setAttribute('data-cfasync', 'true');
      scriptElement.onload = () => {
        installEqualWebLaunchButtonOffscreenStyle();
        initVlibras();
      };

      document.body.appendChild(scriptElement);

      // Botmaker
      if (process.env.VUE_APP_BOTMAKER_URL) {
        const match = document.cookie.match(RegExp('(?:^|;\\s*)d-profile=([^;]*)'));
        const dProfileCookie = match ? match[1] : '';

        window.BOTMAKER_VAR = {
          cookie_accounts: decodeURIComponent(dProfileCookie),
        };

        const botmaker = document.createElement('script');
        botmaker.type = 'text/javascript';
        botmaker.async = true;
        botmaker.src = process.env.VUE_APP_BOTMAKER_URL;
        document.body.appendChild(botmaker);
      }
    },
    showAccessibilityDrawer() {
      Analytics.track('Open accessibility drawer', {
        origin: 'Botão Acessibilidade',
      });

      showEqualWebDrawer();
    },
  },
});
